import TemplateView from '../../../TemplateView'
import ClassicBridge from '../../../next/ClassicBridge'

export default class TextEditor extends TemplateView {
    constructor({
        onChangeCallback = () => {},
        maxInputLength = 2000,
        fieldId,
    }) {
        super()
        this.onChangeCallback = onChangeCallback
        this.maxInputLength = maxInputLength
        this.fieldId = fieldId

        this.state = {
            editable: true,
            editing: false,
            value: null,
        }

        this.onStatePropertyChanged('value', (value) => {
            // null or undefined may be received from server, display them as empty string
            const fixedValue = value || ''
            this.integratedInput.setProps({
                value: fixedValue,
                title: fixedValue
            })
        })

        this.onStatePropertyChanged('editable', (editable) => {
            this.getEl().toggleClass('editable', editable)
            this.integratedInput.setProps({
                disabled: !editable
            })
        })

        this.onStatePropertyChanged('editing', (editing) => {
            this.getEl().toggleClass('editing', editing)
        })
    }

    templateModel() {
        return {
            maxLength: this.maxInputLength
        }
    }

    templateHtml() {
        return "<div class='textEditor atNextMount'></div>"
    }

    afterRender() {
        this.bindClick(this._onClickHandler)
        this.integratedInput = ClassicBridge.integrateInputWithSuggestions(
            this.getEl()[0],
            {
                onChange: this._onInputChange,
                onBlur: this._onBlurHandler,
                onApply: this._onApplyInputValue,
                maxLength: this.maxInputLength,
            },
            this.fieldId
        )
    }

    _onInputChange = (value) => {
        this.integratedInput.setProps({
            value,
        })
    }

    _onApplyInputValue = (value) => {
        // if empty string entered, send null
        const fixedValue = value || null
        // empty string or undefined may be received from server, normalize them to null before comparing
        const stateNormalizedValue = this.state.value || null
        if (fixedValue !== stateNormalizedValue) {
            this.setState({
                value: fixedValue
            })
            this.onChangeCallback(fixedValue)
        }
        this._stopEditing()
    }

    _onClickHandler = () => {
        if (!this.state.editable || this.state.editing)
            return

        this._startEditing()
    }

    _onEscHandler = () => {
        if (this.state.editing)
            this._stopEditing()
    }

    _onBlurHandler = () => {
        if (this.state.editing) {
            this._stopEditing()
        }
    }

    _startEditing() {
        this.setState({editing: true})
        this.integratedInput.setProps({
            focus: true
        })
    }

    _stopEditing() {
        this.setState({editing: false})
        this.integratedInput.setProps({
            focus: false
        })
    }

    remove() {
        // need for remove react node from dom
        this.integratedInput.remove()
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/customFields/TextEditor.js